export const environment = {
  production: true,
  apiURL: 'https://cdh-rgbupmogrowdataprocess-18658.myfrren.com',
  apiKey: 'YaAioQE2ys1HLKMcWlQaz9bqLwAKsy6t3JKhUg0q',
  oktaIssuer: 'https://engie.okta-emea.com/oauth2/default',
  oktaClientId: '0oack284wb9U3brDg0i7',
  admins_users: ['fk6213@engie.com'],
  cdh_project: "cdh_rgbupmogrowdataprocess_18658",
  s3_bucket:"cdh-rgbutruepmogrowprod-568535",
  bucket_construction_key: "rgbu_pmo_grow_constructproject_prod",
  bucket_rampup_key: "rgbu_pmo_grow_capacityrampup_prod",
  athena_construction_table_raw: "rgbu_pmo_grow_constructproject_prod_raw",
  athena_rampup_table_raw:  "rgbu_pmo_grow_capacityrampup_prod_raw",
  athena_construction_table_validated: "rgbu_pmo_grow_constructproject_prod_validated",
  athena_rampup_table_validated:  "rgbu_pmo_grow_capacityrampup_prod_validated",
  construction_s3_path:"rgbu_pmo_grow_constructproject_prod/raw/data.snappy",
  rampup_s3_path:"rgbu_pmo_grow_capacityrampup_prod/raw/data.snappy",
  construction_filename:"data.snappy",
  rampup_filename:"data.snappy",
};
